export default {
  pages: {
    key: "title",
    data: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: "HomeIcon",
        is_bookmarked: false
      },
      {
        title: "Orders",
        url: "/orders",
        icon: "FileIcon",
        is_bookmarked: false
      },
      {
        title: "Account settings",
        url: "/account-settings",
        icon: "SettingsIcon",
        is_bookmarked: false
      }
    ]
  }
};
